import React from 'react';
import c from '../w.js';

const IconStaticStatusSuccess = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
        fill: "#0E8535"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.7072 9.70718L10.5001 16.9143L5.79297 12.2072L7.20718 10.793L10.5001 14.0859L16.293 8.29297L17.7072 9.70718Z",
        fill: "white"
      }
    ))
  )
);

export { IconStaticStatusSuccess };
